import React from "react";
import { useLocation } from "react-router-dom";
import ViewTravelAllowancesPage from "../../../../entities/DashboardPage/HRModule/ViewTravelallowancesPage";

const ViewTravelAllowances = () => {
  const { state } = useLocation();
  const { item } = state || {};

  return (
    <>
      <ViewTravelAllowancesPage item={item} />
    </>
  )

}

export default ViewTravelAllowances;
